import { Pipe, PipeTransform } from '@angular/core';
import { TextFormatters } from '../utils/text-formatters';

@Pipe({
  name: 'checkAge',
})
export class CheckAgePipe implements PipeTransform {
  transform(birthDate: string | undefined | null): number | null {
    if (!birthDate) return null;
    return TextFormatters.checkAge(birthDate);
  }
}
